import { ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useAutoManagedCommissionInfluencersQuery } from '@anytag/graphql';
import {
  AutoManagedCommissionsList,
  AutoManagedCommissionsFilter,
  useAutoManagedCommissionsFilter
} from '@anytag/shared-organisms';
import { useAutoManagedCampaignDetailsContext } from '../auto-managed-campaign-details-context';

export const AutoManagedCommissions = () => {
  const { page, limit, filter } = useAutoManagedCommissionsFilter();
  const { autoManagedCampaignId } = useAutoManagedCampaignDetailsContext();
  const { data, previousData, loading } = useAutoManagedCommissionInfluencersQuery({
    variables: getValuableVariables({
      ...filter,
      limit,
      id: autoManagedCampaignId,
      status: filter.status || null,
      offset: getOffset(page, limit),
      fixedDate: filter.month ? filter.month.split('_')[0] : null
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.autoManagedCommissionInfluencersCounts?.totalNumber;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <AutoManagedCommissionsFilter autoManagedCampaignId={autoManagedCampaignId} />
      <AutoManagedCommissionsList
        loading={loading}
        totalRecords={totalRecords}
        autoManagedCampaignId={autoManagedCampaignId}
        data={result?.autoManagedCommissionInfluencers || []}
      />
    </ListWithPagination>
  );
};
